import { SET_COMPANY_LIST, SET_UPDATED_COMPANY_LIST, SET_BILLING_PLAN, SET_BANKSTATEMENT_LINE_ITEMS, RESET_BANKSTATEMENT_LINE_ITEMS } from "../constants/actionTypes";

export const setCompanyList = (companyList) => {
  return {
    type: SET_COMPANY_LIST,
    companyList,
  };
};

export const setUpdatedCompanyList = (updatedCompanyList) => {
  return {
    type: SET_UPDATED_COMPANY_LIST,
    updatedCompanyList,
  };
};

export const setBillingPlan = (billingPlan) => {
  return {
    type: SET_BILLING_PLAN,
    billingPlan,
  };
};

export const setBankstatementLineItems = (listItems) => {
  return {
    type: SET_BANKSTATEMENT_LINE_ITEMS,
    listItems,
  };
};

export const resetBankstatementLineItems = () => {
  return {
    type: RESET_BANKSTATEMENT_LINE_ITEMS,
  };
};
